/** Медиа игры / «тайминги» (23.08, Марат по жалобе Ильи): секция НЕЗАВИСИМА от
 *  отчёта — файл улетает на сервер СРАЗУ при выборе (POST /:bookingId/material)
 *  и сразу виден клиенту в Юнифансе; заполнять «что делал на игре» для этого
 *  больше не нужно. Ранее залитое (в т.ч. коллегами) подтягивается GET'ом с
 *  подписанными превью; ✕ на своей тумбе снимает привязку (DELETE). Секция
 *  доступна ЛЮБОМУ оператору игры — и напарнику (раньше жила в юнифанс-блоке,
 *  скрытом у напарника, и «на некоторых квестах прикрепить нельзя»). */
import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "../../api/client";
import { MediaThumb, MediaViewer } from "./reportPlayers";
import m from "./opReport.module.css";

interface SrvMat { id: number; kind: string; label: string; duration: string; uploader: string; mine: number; poster: string | null; stream: string | null }
interface UpItem { key: number; f: File; state: "up" | "err" }

/* Тумба уже залитого материала: превью с сервера, длительность, ✕ (снять привязку) */
function SrvThumb({ s, onOpen, onRemove }: { s: SrvMat; onOpen: () => void; onRemove: () => void }) {
  return (
    <div className={m.th} title={`${s.label} · ${s.uploader}`} onClick={onOpen} role="button" style={{ cursor: "pointer" }}>
      {s.poster ? <img className={m.prev} src={s.poster} alt="" loading="lazy" />
        : s.kind === "photo" && s.stream ? <img className={m.prev} src={s.stream} alt="" loading="lazy" />
        : s.kind === "audio" ? "АУДИО" : "ВИДЕО"}
      {s.duration ? <span className={m.dur}>{s.duration}</span> : null}
      <span className={m.ok2}>✓</span>
      <button type="button" className={m.thx} onClick={(e) => { e.stopPropagation(); onRemove(); }} title="Снять файл с игры">✕</button>
    </div>
  );
}

export function MediaSection({ bookingId }: { bookingId: number }) {
  const [srv, setSrv] = useState<SrvMat[]>([]);
  const [ups, setUps] = useState<UpItem[]>([]);
  const [view, setView] = useState<File | null>(null);
  const [viewSrv, setViewSrv] = useState<SrvMat | null>(null);
  const seq = useRef(0);

  const reload = useCallback(async () => {
    const r = await api<{ materials?: SrvMat[] }>(`/api/game-reports/${bookingId}/materials`).catch(() => ({ materials: [] as SrvMat[] }));
    setSrv(r.materials ?? []);
  }, [bookingId]);
  useEffect(() => { void reload(); }, [reload]);

  /* мгновенная загрузка каждого выбранного файла; успех → тумба переезжает в серверные */
  const onFiles = (files: File[]) => {
    for (const f of files) {
      const key = ++seq.current;
      setUps((u) => [...u, { key, f, state: "up" }]);
      const fd = new FormData(); fd.append("file", f);
      void api(`/api/game-reports/${bookingId}/material`, { method: "POST", body: fd, retries: 0 })
        .then(async () => { await reload(); setUps((u) => u.filter((x) => x.key !== key)); })
        .catch(() => setUps((u) => u.map((x) => (x.key === key ? { ...x, state: "err" } : x))));
    }
  };
  const removeSrv = (id: number) => {
    void api(`/api/game-reports/${bookingId}/material/${id}`, { method: "DELETE" }).then(() => reload()).catch(() => {});
  };

  return (
    <section className={m.hud}>
      <div className={m.hh}>Медиа для клиента</div>
      <div className={m.media}>
        {srv.map((s) => <SrvThumb key={s.id} s={s} onOpen={() => setViewSrv(s)} onRemove={() => removeSrv(s.id)} />)}
        {ups.map((u) => (
          <MediaThumb key={u.key} f={u.f} done={false} onOpen={() => setView(u.f)}
            onRemove={() => setUps((x) => x.filter((y) => y.key !== u.key))} />
        ))}
        <label className={`${m.th} ${m.addm}`} title="Добавить фото / видео / аудио — улетает сразу">+
          <input type="file" accept="image/*,audio/*,video/*" multiple style={{ display: "none" }}
            onChange={(e) => { onFiles(Array.from(e.target.files ?? [])); e.target.value = ""; }} />
        </label>
      </div>
      {ups.some((u) => u.state === "up") ? <div className={m.sub}>загружаю…</div>
        : ups.some((u) => u.state === "err") ? <div className={m.sub}>часть не загрузилась — убери ✕ и добавь заново</div> : null}
      <MediaViewer file={view} onClose={() => setView(null)} />
      {viewSrv ? ( /* лайтбокс серверного материала — в стиле MediaViewer */
        <div onClick={() => setViewSrv(null)} role="dialog" aria-modal="true"
          style={{ position: "fixed", inset: 0, zIndex: "calc(var(--z-modal) + 70)", background: "var(--black-a60)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 14 }}>
          {viewSrv.kind === "video" ? <video src={viewSrv.stream ?? undefined} poster={viewSrv.poster ?? undefined} controls autoPlay playsInline onClick={(e) => e.stopPropagation()} style={{ maxWidth: "100%", maxHeight: "88dvh" }} />
            : viewSrv.kind === "audio" ? <audio src={viewSrv.stream ?? undefined} controls autoPlay onClick={(e) => e.stopPropagation()} style={{ width: "min(320px, 90vw)" }} />
            : <img src={viewSrv.stream ?? viewSrv.poster ?? ""} alt="" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "100%", maxHeight: "88dvh", objectFit: "contain" }} />}
        </div>
      ) : null}
    </section>
  );
}
